import React from "react";
import { CheckCircle } from "lucide-react";

const nationalNumber = (value = "") => value
  .trim()
  .replace(/^\+?91[\s-]*/, "")
  .replace(/\D/g, "")
  .slice(0, 10);

export const formatIndianPhone = (value = "") => {
  const digits = nationalNumber(value);
  return digits ? `+91 ${digits}` : "";
};

export const PhoneNumberInput = ({
  value = "",
  onChange,
  testId,
  required = false,
  disabled = false,
  verified = false,
  verifying = false,
  onVerify,
  verifyLabel = "Verify",
  className = "",
}) => {
  const updateNumber = (event) => {
    const digits = event.target.value.replace(/\D/g, "").slice(0, 10);
    onChange(digits ? `+91 ${digits}` : "");
  };

  return (
    <div
      className={`mt-1 flex min-w-0 overflow-hidden rounded-lg border border-[#E2DCD2] bg-white focus-within:ring-2 focus-within:ring-[#2D5A47] ${className}`}
      data-testid={`${testId}-phone-control`}
    >
      <span
        className="flex shrink-0 items-center border-r border-[#E2DCD2] bg-[#F4F1EA] px-3 text-sm font-semibold text-[#1E2A24]"
        data-testid={`${testId}-country-prefix`}
      >
        +91
      </span>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        value={nationalNumber(value)}
        onChange={updateNumber}
        placeholder="98765 43210"
        required={required}
        disabled={disabled}
        className="min-w-0 flex-1 bg-white px-3 py-2.5 text-sm outline-none disabled:bg-[#F4F1EA]"
        data-testid={testId}
        aria-label="Indian mobile number"
      />
      {verified ? (
        <span
          className="inline-flex shrink-0 items-center gap-1 px-3 text-xs font-semibold text-emerald-700"
          data-testid={`${testId}-verified-status`}
        >
          <CheckCircle size={14} aria-hidden="true" />
          Verified
        </span>
      ) : onVerify && (
        <button
          type="button"
          onClick={onVerify}
          disabled={disabled || verifying}
          className="shrink-0 px-3 text-xs font-semibold text-[#2D5A47] disabled:opacity-60"
          data-testid={`${testId}-verify-button`}
        >
          {verifying ? "Starting…" : verifyLabel}
        </button>
      )}
    </div>
  );
};